import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { FuseNavigation, FuseLayouts } from '@fuse';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Extension from '@material-ui/icons/Extension';
import DescriptionIcon from '@material-ui/icons/Description';
import Config from '../config';
import Cookies from 'universal-cookie';
import EndpointsGetter from './content/common/EndpointsGetter';
import axiosInstance from "./content/common/AxiosInstace";
import { getUserData } from "../store/selectors/index";
import { isAllowed, authRoles } from "../auth/auth";

const cookies = new Cookies();
const styles = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        'flex-direction': 'column'
    },
    version: {
        color: 'white',
        'margin-top': 10,
        'margin-left': 10
    },
    menuList: {
        marginTop: 0,
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& $primary, & $icon': {
                color: theme.palette.common.white
            }
        },
        marginTop: 0,
        paddingRight: 0,
        paddingLeft: 0
    },
    primary: {
        fontSize: 14,
        marginLeft: 0,
    },
    icon: {
        marginRight: 0,
        marginLeft: 20,
        transform: 'scale(0.7)'
    }
});

class MainNavbarContent extends Component {

    getAccountDetails() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getAccountDetailsEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                MainNavbarContent.redirectToLoaderGun(response.data.userId, response.data.accountId, response.data.accountUrl);
            })
            .catch(error => {
                console.log(error);
            });
    }

    static redirectToLoaderGun(userId, accountId, accountUrl) {
        let cookieExpiry = Date.now() + 60 * 1000;
        let url = window.location.href;

        if (url.includes("localhost")) {
            cookies.set('access_token', localStorage.getItem("access_token"), { path: '/', expires: new Date(cookieExpiry) });
            cookies.set('refresh_token', localStorage.getItem("refresh_token"), { path: '/', expires: new Date(cookieExpiry) });
            cookies.set('user_id', userId, { path: '/', expires: new Date(cookieExpiry) });
            cookies.set('account_id', accountId, { path: '/', expires: new Date(cookieExpiry) });
            cookies.set('account_url', accountUrl, { path: '/', expires: new Date(cookieExpiry) });
            window.open('http://localhost:4000/#/configs-list');
        } else {
            cookies.set('access_token', localStorage.getItem("access_token"), { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
            cookies.set('refresh_token', localStorage.getItem("refresh_token"), { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
            cookies.set('user_id', userId, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
            cookies.set('account_id', accountId, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });
            cookies.set('account_url', accountUrl, { path: '/', expires: new Date(cookieExpiry), domain: '.kanin.io', secure: true });

            if (url.includes("elb.kanin.io") || url.includes("dev.kanin.io")) {
                window.open('https://loadergun-dev.kanin.io/#/configs-list', '_blank');
            } else if (url.includes("qa.kanin.io")) {
                window.open('https://loadergun-qa.kanin.io/#/configs-list', '_blank');
            } else {
                window.open('https://loadergun.kanin.io/#/configs-list', '_blank');
            }
        }
    }

    handleApiDocClick = () => {
        window.open(Config.apiUrl + '/docs/swagger-ui.html', '_blank');
    };

    render() {
        const { theme, navigation, layoutStyle, user } = this.props;
        const navigationLayout = FuseLayouts[layoutStyle].type;
        const commitId = '';
        const timestamp = new Date().toISOString();

        return (
            <div style={{ 'height': '100vh', overflow: 'hidden', display: 'flex', 'flexDirection': 'column' }}>
                <div>
                    <FuseNavigation navigation={navigation} layout={navigationLayout} />
                    {
                        isAllowed(user, authRoles.exceptViewer) ? (
                            <MenuList style={{ marginTop: 0, paddingTop: 0, paddingBottom: 0 }}>
                                <MenuItem
                                    style={{
                                        '&:focus': {
                                            backgroundColor: theme.palette.primary.main,
                                            '& $primary, & $icon': { color: theme.palette.common.white }
                                        },
                                        marginTop: 0, paddingRight: 0, paddingLeft: 0
                                    }}
                                    onClick={this.getAccountDetails}>
                                    <ListItemIcon style={{ marginRight: 0, marginLeft: 20, transform: 'scale(0.7)' }}>
                                        <Extension />
                                    </ListItemIcon>
                                    {!this.props.settings.layout.config.navbar.folded || this.props.navbar.mobileOpen ?
                                        <ListItemText style={{ fontSize: 14, marginLeft: 0, }} inset primary="Loader Gun" /> : null
                                    }
                                </MenuItem>
                                <MenuItem
                                    style={{
                                        '&:focus': {
                                            backgroundColor: theme.palette.primary.main,
                                            '& $primary, & $icon': { color: theme.palette.common.white }
                                        },
                                        marginTop: 0, paddingRight: 0, paddingLeft: 0
                                    }}
                                    onClick={this.handleApiDocClick}>
                                        <ListItemIcon style={{ marginRight: 0, marginLeft: 20, transform: 'scale(0.7)' }}>
                                            <DescriptionIcon />
                                        </ListItemIcon>
                                        {!this.props.settings.layout.config.navbar.folded || this.props.navbar.mobileOpen ?
                                            <ListItemText style={{ fontSize: 14, marginLeft: 0, }} inset primary="API Documentation" /> : null
                                        }
                                </MenuItem>
                            </MenuList>
                        ) : null
                    }
                </div>
                {!this.props.settings.layout.config.navbar.folded || this.props.navbar.mobileOpen ?
                    <div style={{ color: 'white', 'bottom': 8, 'left': 16, 'position': 'absolute', 'fontSize': '1.5vh' }}>
                        v.{Config.versionNumber} #{Config.buildVersion}
                    </div> : null
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

const mapStateToProps = (state, ownProps) => {
    const userData = getUserData(state).user;
    return {
        user: userData,
        navigation: state.fuse.navigation,
        layoutStyle: state.fuse.settings.current.layout.style
    };
};

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MainNavbarContent)));


// WEBPACK FOOTER //
// ./src/main/MainNavbarContent.js